import React from "react";
import "./Customers.css";

import KUBECON_LOGO from "../../assets/images/Kubecon_Horiz.svg";
import OCULUSHEALTH_IMAGE from "../../assets/images/oculushealth.png";
import MEDICHANDS_IMAGE from "../../assets/images/medichands.png";

const Customers = (props) => {
    return (
        <div id="customers">
            <div className="grid">
                <div className="header col-12">Customer Satisfaction is Our Main Priority</div>
                <div className="col-2"></div>
                {customersData.map(data=>Customer(data))}
            </div>
        </div>
    )
}

const Customer = (props) => {
    return (
    <div className="col-10_sm-12" data-push-left="off-1_sm-0" key={props.id}>
        <img className="customer-image" alt="" src={props.image} />
        <div className="headline">{props.person}</div>
        <p className="body">{props.review}</p>
    </div>
    )
}

const customersData = [
    {id: 1, person: "Sridhar Yerramreddy - Oculushealth", image: OCULUSHEALTH_IMAGE, url: "https://oculushealth.com", review: "Our previous IT infrastructure was complicated and we had no way of tracking so many pieces, guys at Tysonworks helped us through migrating our workloads to AWS using Microservices and Serverless patterns. We have now confidence in our system and we are paying less and having more performance out of our applications."},
    {id: 2, person: "Harun Gurcan - Medichands", image: MEDICHANDS_IMAGE, url: "https://medichands.com", review: "Consultants at TysonWorks helped us setting our Cloud Infrastructure on Amazon Web Services, created DevOps pipelines and helped us reduce our IT costs. We recommend them to any company who is looking forward to enjoying the true benefits of Cloud computing."},
    // {id: 2, image: KUBECON_LOGO, url: "https://cncf.com", review: "Helped us really well, thanks"},
    // {id: 3, image: KUBECON_LOGO, url: "https://cncf.com", review: "Helped us really well, thanks"}
];

export default Customers;